import {  Box, useTheme, useMediaQuery } from "@mui/material";

import { BffWorkingHours } from "@/graphql/__generated/sdk";
import { getLocalTimeFromTimeZone } from '@/utils/getLocalTimeFromTimeZone';
import { getTodayCloseTime, isOfficeOpen } from "@/components/GoogleMap/StandardGoogleMap/LocationCard/LocationStatus.helpers";

import CustomTypography from "./UI/Typography/CustomTypography";
import { colors } from "./UI/colors";

const OfficeStatus = ({
	workingHours,
	timeZoneId,
}: {
	workingHours: BffWorkingHours[];
	timeZoneId?: string;
}) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const localCurrenTimeDetails = getLocalTimeFromTimeZone(timeZoneId || '');
	
	const { localDayOfWeek, localTime, localAmOrPm } = localCurrenTimeDetails;
	const hours = workingHours?.filter((hour) => hour.date === localDayOfWeek);
	const isOfficeOpenNow = isOfficeOpen(hours, localTime, localAmOrPm);
	const closeTime = getTodayCloseTime(hours);

	return (
		<Box textAlign="left">
			<CustomTypography variant={isSmallScreen ? "bodySBold" : "bodyS"} sx={{ color: isOfficeOpenNow ? colors.text.success : colors.text.error }}>
				{isOfficeOpenNow ? "Open" : "Closed"}  •
			</CustomTypography>{" "}
			{isOfficeOpenNow ? (
				<CustomTypography
					variant="bodyS"
				>
				Closes at {closeTime}
				</CustomTypography>
			) : null}
		</Box>
	);
};

export default OfficeStatus;
